import { ENUM__local_event } from '@/services/events/ENUM__local_event';
import { service_local_events } from '@/services/events/service_local_events';

export function HANDLER_CLIENT__user_auth_failed(data: any) {
  service_local_events.emit(ENUM__local_event.USER_AUTH_FAILED);
}
